module.exports = __webpack_public_path__ + "static/media/1O2A0778.5b643b26.jpg";